// extracted by mini-css-extract-plugin
export default {"globalFonts":"fonts_globalFonts__YwI27"};